export default Object.freeze({
	BUSINESS: 'business',
	HOME: 'home',
	BILLING: 'billing',
	POSTAL: 'postal',
	HEAD_OFFICE: 'headoffice',
	OTHER: 'other',
});
